module.exports = __webpack_public_path__ + "static/media/popup1-min.23d4db22.png";